import React from "react";
//#region types
import { SubTitleWithIconProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Typography } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const SubTitleWithIcon: React.FC<SubTitleWithIconProps> = (props) => {
  return (
    <Typography className={cssExports.subTitleWithIcon}>
      <Icon icon={props.icon} />
      {props.subTitle}
    </Typography>
  );
};

export default SubTitleWithIcon;
